module.exports = __webpack_public_path__ + "static/media/MaskGroup23.9416d8b7.png";